import { Table, flexRender } from '@tanstack/react-table';
import { TableCell, TableFooter, TableRow } from '@sib/ui';

interface DataTableFooterProps<T> {
  table: Table<T>;
}

export const DataTableFooter = <T,>({ table }: DataTableFooterProps<T>) => (
  <TableFooter>
    {table.getFooterGroups().map(footerGroup => (
      <TableRow key={footerGroup.id}>
        {footerGroup.headers.map(header => (
          <TableCell
            key={header.id}
            data-testid={header.column.columnDef.meta?.cellDataTestId}
          >
            {flexRender(header.column.columnDef.footer, header.getContext())}
          </TableCell>
        ))}
      </TableRow>
    ))}
  </TableFooter>
);
